<template>
  <ValidationObserver ref="form" tag="div">
    <b-form class="form--auth"
            @submit.prevent
            v-stream:submit="onLogin$"
            >
      <template>
        <h3 class="heading">商戶附屬帳戶登入</h3>
        <h3 class="sub-heading">供掃描二維碼用</h3>
        <transition name="fade">
          <NotificationMessage v-if="error" customStyle="padding:  15px 12px;"
          >登入失敗 : <span>{{error}}</span>
          </NotificationMessage>
        </transition>
        <AGCInput v-model="merchantName"
                  name="主帳戶名稱"
                  rules="required"
                  placeholder="主帳戶名稱"
                  required
                  @input="clearError"
        ></AGCInput>
        <AGCInput v-model="subMerchantName"
                  name="附屬帳戶名稱"
                  rules="required"
                  placeholder="附屬帳戶名稱"
                  required
                  @input="clearError"
        ></AGCInput>
        <AGCInput v-model="password"
                  vid="password"
                  name="附屬帳戶密碼"
                  type="password"
                  rules="required"
                  class="mb-3"
                  placeholder="附屬帳戶密碼"
                  required
                  @input="clearError"
        ></AGCInput>
        <b-button type="submit"
                  variant="primary"
                  size="lg"
                  :disabled="loading"
                  block
        >
          登入
        </b-button>
        <div class="d-flex justify-content-center mt-3">
          <a href="https://www.ulifestyle.com.hk/merchantcenter/tnc" target="_blank" style="color: #707477;">條款及細則</a>
        </div>
      </template>
      <div v-if="loading" class="form__overlay">
        <LoadingSpinner></LoadingSpinner>
      </div>
    </b-form>
  </ValidationObserver>
</template>

<script>
import { tap, switchMap } from 'rxjs/operators';
import {
  BForm,
  BButton,
} from 'bootstrap-vue';
import http from '../../helpers/new-http';
import { getErrorMsg } from '../../helpers/error-msg';
import { SET_USER } from '../../store';
import formMixin from '../../mixins/form';
import AGCInput from '../../components/form/AGCInput.vue';
import LoadingSpinner from '../../components/LoadingSpinner.vue';
import NotificationMessage from '../../components/NotificationMessage.vue';

const ERRORS = {
  UNAUTHORIZED: '請確定輸入正確帳戶名稱及密碼',
  USER_NO_PERMISSION: '你的帳號已被停用',
};

export default {
  mixins: [formMixin],
  components: {
    BForm,
    BButton,
    LoadingSpinner,
    AGCInput,
    NotificationMessage,
  },
  data: () => ({
    merchantName: null,
    subMerchantName: null,
    password: null,
    loading: false,
    error: null,
  }),
  methods: {
    clearError() {
      this.error = null;
    },
  },
  computed: {
    role() {
      return this.$route.meta.role;
    },
  },
  domStreams: ['onLogin$'],
  subscriptions() {
    return {
      login: this.onLogin$
        .pipe(
          switchMap(this.validate),
          tap(() => {
            this.loading = true;
          }),
          switchMap(() => http({
            method: 'POST',
            url: '/agc-sub-merchant-api/auth/loginSubMerchant',
            data: {
              merchantName: this.merchantName,
              subMerchantName: this.subMerchantName,
              password: this.password,
            },
          }, {
            next: (res) => {
              const user = {
                id: res.id,
                username: res.username,
                role: 'sub-merchant',
              };
              localStorage.setItem('token', res.token);
              localStorage.setItem('username', res.username);
              localStorage.setItem('merchantId', res.merchantId);
              localStorage.setItem('role', 'sub-merchant');
              localStorage.setItem('id', res.id);
              this.$store.commit(SET_USER, user);
              this.$router.replace({
                path: this.$route.query.redirect || '/qr-scanner',
              });
            },
            error: ({ data: { msg } }) => {
              this.error = getErrorMsg(msg, ERRORS);
            },
            complete: () => {
              this.loading = false;
            },
          })),
        ),
    };
  },
  mounted() {
    this.$emit('updated');
  },
};
</script>

<style lang="scss">
@import "../../assets/scss/form--auth";
</style>

<style scoped lang="scss">
.form {
  &__remember {
    font-size: 14px;
    color: #636d77;

    &::v-deep .custom-control-label {
      &::before, &::after {
        top: 0.13rem;
      }
    }
  }

  &__forget-pw {
    color: #1a73e8;
    font-weight: 400;
    font-size: 0.875rem;

    &:hover {
      text-decoration: none;
    }
  }
}

h3.heading{
  margin-bottom: 0px;
}
h3.sub-heading{
  font-size: 0.8em;
}
</style>
